import { FC } from 'react';
import { employeesList } from '@/common/api/employee';
import Fuzzy from './Fuzzy';
import { isArray } from '@lhb/func';

const Employees: FC<any> = ({
  finallyData,
  showUserMobile = false,
  ...props
}) => {
  const loadData = async (keyword?: string) => {
    const params = {
      keyword
    };
    const res = await employeesList(params);
    const data = isArray(res) ? (showUserMobile ? res.map((item) => ({
      ...item,
      name: `${item.name}${item.mobile ? ' ' + item.mobile : ''}`
    })) : res) : [];
    finallyData && finallyData(data);
    return Promise.resolve(data);
  };

  return (
    <Fuzzy
      loadData={loadData}
      fieldNames={{
        label: 'name',
        value: 'id'
      }}
      {...props}/>
  );
};

export default Employees;
